<div class="overflow-x-auto w-full">
  <div class="grid grid-flow-col auto-cols-[1fr] gap-2 items-center">
    @for (tab of tabs(); track tab.label) {
      <button
        type="button"
        [class]="
          'btn w-full min-w-[80px] whitespace-nowrap cursor-pointer rounded-(--tabs-border-radius) p-(--tabs-padding) font-(--tabs-font-weight) ' +
          (tab.isActive
            ? 'text-(--tabs-selected-color) bg-(--tabs-selected-background)'
            : 'text-(--tabs-color) hover:text-(--tabs-selected-color) hover:bg-(--tabs-selected-background)')
        "
        (click)="onTabClick(tab)"
      >
        {{ tab.label | translate }}
      </button>
    }
  </div>
</div>
